const PAYMENT_OPTION_KEY_PREFIX = "rbPayrollOwnerPaymentOption:";

const wait = (ms: number = 200) => new Promise((resolve) => setTimeout(resolve, ms));

const getPaymentOptionKey = (locationId: string) => `${PAYMENT_OPTION_KEY_PREFIX}${locationId}`;

export const rbPayrollOwnerMockApi = {
  async getSelectedPaymentMethod(locationId: string): Promise<string> {
    await wait();
    return localStorage.getItem(getPaymentOptionKey(locationId)) || "";
  },

  async saveSelectedPaymentMethod(locationId: string, paymentMethod: string): Promise<string> {
    await wait(200);

    if (!paymentMethod) {
      localStorage.removeItem(getPaymentOptionKey(locationId));
      return "";
    }

    localStorage.setItem(getPaymentOptionKey(locationId), paymentMethod);
    return paymentMethod;
  },

  async deleteDocument(): Promise<void> {
    await wait(150);
  },
};
